export enum StatoLicenza {
    Attiva,
    NonAttiva,
    InScadenza,
    NonTrovata
}
